import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../components/navbar";
import Footer from "../components/footer";
import { useLocation } from "react-router-dom";
import ShowNavbar from "../components/navbar/ShowNavbar";

const RootLayout = () => {
  const location = useLocation();
  return (
    <div>
      <div style={{ position: "absolute", zIndex: 999 }}>
        <ShowNavbar />
      </div>
      <div style={{ display: location.pathname === "/" ? "none" : "block" }}>
        <Navbar />
      </div>
      <Outlet />
      <Footer />
    </div>
  );
};

export default RootLayout;
